import React, {useEffect, useState} from 'react';
import ReactTable from '../../ReactTable';
import * as PropTypes from "prop-types";
import { fetchConfigs, deleteConfig, activateConfig } from '../../../pages/AssistConfig/helper';
import AssistConfigBaseTableColumns from './AssistConfigBaseTableColumns';
import CreateNewConfigForm from '../../forms/CreateNewConfigForm';
import ModalComponent from '../../modal/ModalComponent';
import ActionModal from '../../ActionModal';
import { Tooltip } from 'react-tooltip';

const AssistConfigBaseTable = ({ needToUpdate, setNeedToUpdate }) => {
	const [configsData, setConfigsData] = useState([]);

	const [selectedConfig, setSelectedConfig] = useState(null);
	const [selectedConfigData, setSelectedConfigData] = useState({});

	const [isEditModalOpen, setIsEditModalOpen] = useState(false);
	const [isActiveModalOpen, setIsActiveModalOpen] = useState(false);
	const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
	const [isLoading, setIsLoading] = useState(false);

	useEffect(() => {
		if(needToUpdate) {
			fetchConfigs(setConfigsData, setIsLoading);
			setNeedToUpdate(false);
		}
	}, [needToUpdate])
	
	const onModalOpen = (value, content) => {
		setSelectedConfig(value);
		
		if(content === 'delete') {
			setIsDeleteModalOpen(true);
		}

		if(content === 'edit') {
			setSelectedConfigData(configsData?.configs?.find(unit => unit.id === value));
			setIsEditModalOpen(true);
		}

		if(content === 'active') {
			setSelectedConfigData(configsData?.configs?.find(unit => unit.id === value));
			setIsActiveModalOpen(true);
		}
	};
	
	const onSort = (e) => console.log(e);

	const onRejectButtonClick = () => {
		setIsDeleteModalOpen(false);
		setSelectedConfig(null);
	}

	const onConfirmButtonClick = () => {
		deleteConfig(
			selectedConfig,
			configsData,
			setConfigsData,
			setIsLoading,
			onRejectButtonClick
		)
	}

	const onActivateRejectButtonClick = () => {
		setIsActiveModalOpen(false);
		setSelectedConfig(null);
	}

	const onActivateButtonClick = () => {
		activateConfig(
			selectedConfig,
			!selectedConfigData?.active,
			setNeedToUpdate,
			setIsLoading,
			onActivateRejectButtonClick
		)
	}
	
	return (
		<>
			<ReactTable
				columns={AssistConfigBaseTableColumns({ onModalOpen })}
				data={configsData.configs}
				onSortChange={onSort}
				loading={isLoading}
				manualSortBy
				disableMultiSort
				disableSortBy={true}
			/>
			<Tooltip id="table-tooltip" />

			{isEditModalOpen && (
				<ModalComponent
					isModalOpen={isEditModalOpen}
					modalHeaderTitle="Edit AI Notification Trigger"
					toggleModal={() => setIsEditModalOpen(!isEditModalOpen)}
					isModalFooter={false}
				>
					<CreateNewConfigForm
						entryData={selectedConfigData}
						closeModal={() => setIsEditModalOpen(!isEditModalOpen)}
						updateData={() => setNeedToUpdate(true)}
					/>
				</ModalComponent>
			)}

			{isDeleteModalOpen && (
				<ActionModal
					isOpen={isDeleteModalOpen}
					confirm={onConfirmButtonClick}
					confirmLabel="Delete"
					reject={onRejectButtonClick}
					rejectLabel="Cancel"
					headerText={`Delete AI Notification Trigger?`}
				>
					<div className='mt-2'>
						Deleting this notification configuration is permanent.
						All associated data will be permanently removed and cannot be recovered.
						Please confirm that you want to proceed, as this action cannot be undone.
					</div>
				</ActionModal>
			)}

			{isActiveModalOpen && (
				<ActionModal
					isOpen={isActiveModalOpen}
					confirm={onActivateButtonClick}
					confirmLabel={selectedConfigData?.active ? 'Deactivate' : 'Activate'}
					reject={onActivateRejectButtonClick}
					rejectLabel="Cancel"
					headerText={`${selectedConfigData?.active ? 'Deactivate' : 'Activate'} AI Notification Trigger?`}
				>
					<div className='mt-2'>
						Changing the status of this notification configuration will immediately affect its behavior.
						Deactivating will disable all associated alerts, while activating will enable them.
						Please confirm that you want to proceed, as this action takes effect immediately.
					</div>
				</ActionModal>
			)}
		</>
	);
};

AssistConfigBaseTable.propTypes = {
	needToUpdate: PropTypes.bool,
	setNeedToUpdate: PropTypes.func,
	page: PropTypes.number,
};

export default AssistConfigBaseTable;
